import { menuReportingGroupCardFactory } from './chunk-C5AX5WMK.mjs';
import pickBy from 'lodash/pickBy';

var menuItemReportingGroupsFactory = (reportingGroups, assignedReportingGroups) => {
  const reportingGroupsToRender = pickBy(
    reportingGroups,
    (reportingGroup) => assignedReportingGroups.includes(reportingGroup.reportingGroupId)
  );
  return menuReportingGroupCardFactory(reportingGroupsToRender);
};

export { menuItemReportingGroupsFactory };
